import {useContext} from 'react';
import { BrowserRouter as Router, Routes, Route  } from "react-router-dom";
import AppLayout from './Components/AppLayout'

import Login from './Pages/Login'
import Guidelines from './Pages/Guidelines'
import Dashboard from './Pages/Dashboard'
import Apply from './Pages/Apply'
import Applications from './Pages/Applications'
import Accepted from './Pages/Accepted'
import Rejected from './Pages/Rejected'
import Corrected from './Pages/Corrected'
import Payment from './Pages/Payment'
import Confirmation from './Pages/Confirmation'
import UploadVerification from './Pages/UploadVerification';
import UploadDocument from './Pages/UploadDocument';
import PrintAdmissions from './Pages/PrintAdmissions'

// import Payment from './Pages/Payment'
// import Confirmation from './Pages/Confirmation'
// import UnpaidFee from './Pages/UnpaidFee'



import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import '../src/index.css'
import '../src/Style.css'


import {AuthContext} from './context/AuthContext';

function App() {
  const {userInfo, splashLoading} = useContext(AuthContext);
  const isProduction = process.env.NODE_ENV === 'production';
 
  return (

      <Router>
        <Routes>
          <Route element={<AppLayout />}>  
            <Route path="registration/dashboard" element={<Dashboard/>} />
            <Route path="registration/guidelines" element={<Guidelines/>} />
            <Route path="registration/students" element={<Applications/>} />
            <Route path="registration/applications/registered" element={<Accepted/>} />
            <Route path="registration/applications/rejected" element={<Rejected/>} />
            <Route path="registration/applications/corrected" element={<Corrected/>} />
            <Route path="registration/application" element={<Apply/>} />
            <Route path="registration/print" element={<PrintAdmissions/>} />
            <Route path="registration/application/:registrationID" element={<Apply/>} />
            <Route path="registration/verification/:registrationID" element={<UploadVerification/>} />
            <Route path="registration/scrutiny/objection/:registrationID/:document" element={<UploadDocument/>} />
            <Route path="registration/payment/:challanNo" element={<Payment/>} />
            <Route path="registration/payment/confirmation/:transaction" element={<Confirmation/>} />
          </Route>
          <Route exact  path="/login" element={<Login/>} />
          <Route exact  path="/" element={<Login/>} /> 
        </Routes>
      </Router>


  );
}

export default App;
